import { render } from "./ClientAction.vue?vue&type=template&id=557ace45&scoped=true"
import script from "./ClientAction.vue?vue&type=script&lang=js"
export * from "./ClientAction.vue?vue&type=script&lang=js"

import "./ClientAction.vue?vue&type=style&index=0&id=557ace45&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557ace45"]])

export default __exports__